<template>
  <VisibilityTransfers variant="open" />
</template>

<script lang="tsx" setup>
import VisibilityTransfers from '@pages/visibility/visibilityTransfer/VisibilityTransfers.vue';
</script>

<style lang="scss" scoped>
</style>
